import { LocationRefService } from './../../../shared/services/LocationRef.service';
import { CartService } from 'projects/shared/services/cart.service';
import { AuthService } from './../../../shared/services/auth.service';
import { ExchangeService } from './../../../shared/services/exchange.service';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2,
} from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { IUser, UserRegionType } from 'projects/shared/models/interfaces/user.model';
import { Subscription, debounceTime, distinctUntilChanged, filter, noop, skip, take, tap } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { LinksService } from 'projects/shared/services/links.service';
import { CanonicalService } from 'projects/shared/services/canonical.service';
import { LightModeService } from './+shared/services/light-mode.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './+shared/services/language.service';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { BrowserService } from 'projects/shared/services/browser.service';
import { WebSettingService } from 'projects/shared/services/web-setting.service';
import { IWebSetting } from 'projects/shared/models/interfaces/IWebSetting';
import { TicketSocketService } from 'projects/shared/services/ticket-socket.service';
import { TargetAlertsService } from './+shared/services/targe-alerts.service';
import { makeQueryParams } from './../../../admin/src/app/shared/helpers/makeQueryParams';
import { MessageService } from 'primeng/api';
import { CrispChatService } from 'projects/shared/services/crisp-chat.service';
import { CookieService } from 'ngx-cookie-service';
import { MobileToasterService } from 'projects/shared/components/mobile-toaster/services/mobile-toaster.service';
import { AnalyticsTracker } from './+shared/trackers/analytics.tracker';
import { AnalyticsService } from './+shared/services/analytics.service';
import { StopAutoScrollService } from './modules/categories/services/stop-auto-scroll.service';
import { DesktopToaster } from 'projects/shared/services/desktop-toaster.service';
import { SeoService } from 'projects/shared/services/seo.service';


declare let dataLayer: any[];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  isVisible: boolean = false;
  showHeader = true;
  user!: IUser | null;

  showLoading = true;
  subscription: Subscription = new Subscription();
  lightMood = false;

  activeCurrency!: string;
  arabic = false;
  webSettingConfig!: IWebSetting;
  UserRegion: UserRegionType = {} as UserRegionType;

  _analyticsTracker = new AnalyticsTracker();
  constructor(
    public router: Router,
    private authServ: AuthService,
    private storeChangeServ: StoreChangesService,
    private exchangeServ: ExchangeService,
    private cartService: CartService,
    private meta: Meta,
    private titleService: Title,
    private renderer: Renderer2,
    private linksService: LinksService,
    private lightModeService: LightModeService,
    private _translateService: TranslateService,
    private _languageService: LanguageService,
    private browserService: BrowserService,
    private _targetAlertsService: TargetAlertsService,
    private _messageService: MessageService,
    private _crispChatService: CrispChatService,
    private _analyticsService: AnalyticsService,
    private canonicalService: CanonicalService,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private document: Document,
    private webSettingService: WebSettingService,
    private _desktopToaster: DesktopToaster,
    private seoService: SeoService
  ) {
    this.onlineAuth()
    this.getThameBody();


    this.router.events.subscribe(event => {
      if (event instanceof NavigationError) {
        if (event.error.name === 'ChunkLoadError') {
          if (typeof window !== 'undefined') {
            window.location.reload();
          }
        }
      }
      if (event instanceof NavigationEnd) {
        if (typeof window !== 'undefined' && (window as any).dataLayer) {
          (window as any).dataLayer.push({
            event: 'pageview',
            pagePath: event.urlAfterRedirects
          });
        }
      }
    });
  }

  onlineAuth() {
    let params: any;

    if (this.browserService.getLocation()) params = this.extractQueryParams(location.href)
    if (this.browserService.getSessionStorage() && params.token) sessionStorage.setItem('token', params.token)
  }
  extractQueryParams(url: string) {
    const queryString = url?.split('?')[1]?.split('#')[0]; // Get query parameters part
    const params = new URLSearchParams(queryString);
    return Object.fromEntries(params.entries());
  }
  public throwTestError(): void {
    throw new Error("Sentry Test Error");
  }

  getCurrentCountry() {
    this.subscription.add(
      this.authServ.getSuggestLanguage().pipe(
        tap(
          res => {
            this.authServ.currentCountry.next(res);
          }
        )
      ).subscribe(noop)
    )
  }




  getThameBody() {
    // const body = document.querySelector('body');
  }

  changeSiteMode() {
    this.lightModeService.lightMood.subscribe(
      res => {
        this.lightMood = res;
      }
    )
  }

  ngOnInit(): void {
    this._crispChatService.onInit();
    // this.getTargetAlerts();

    const localStorageBr = this.browserService.getLocalStorage();

    if (localStorageBr) {
      localStorage.removeItem("mainCategoryList");
    }
    this.validateUser()
    const windowBr = this.browserService.getWindow();
    if (windowBr) {
      this.scrollTop();
    }
    this.changeSiteMode()

    this.webSetting()

    this.metaPixel()

    this._desktopToaster.desktopToaster$.pipe(
      filter(data => data !== null),
      tap(
        data => {
          this._messageService.add(data)
        }
      )
    ).subscribe()

  }



  metaPixel() {
    this._analyticsService.initialize('6580004642019541');

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => {
          this._analyticsTracker.viewPage(this.browserService.getLocation()?.pathname!);
        }, 100);
      });
  }

  webSetting() {
    this.webSettingService.getWebsetting().subscribe(response => {
      this.webSettingConfig = response
      this.storeChangeServ.setWalletShow(this.webSettingConfig.hide_wallet)
      this.updateMetaTags();
      if (isPlatformServer(this.platformId)) {
        this.addStructuredData();
      }
    })
  }
  scrollTop() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        window.scroll(0, 0);
      });
  }

  handlingTranslateWhenStart() {
    this.storeChangeServ.getUser().pipe(
      debounceTime(0),
      tap(user => {
        if (!user) {
          this.getCurrentCountry();
          this.authServ.currentCountry.pipe(
            skip(1),
            tap(
              res => {
                this.UserRegion = {
                  country: res.country,
                  currency: res.suggestedCurrency,
                  lang: res.suggestedLanguage ?? 'en'
                }
                this._languageService.arabic.next(res.suggestedLanguage == 'ar');
                if (!this.browserService.getLocalStorage()?.getItem('UserRegion')) {
                  this.browserService.getLocalStorage()?.setItem('UserRegion', JSON.stringify(this.UserRegion));
                }
                this.storeChangeServ.setUserRegiona(this.UserRegion);
                this.setTranslateLocalstorgeAndDir()
              }
            )
          ).subscribe()
        }
      }),
      filter(user => user !== null),
      tap(
        res => {
          this.user = res;
          if (this.user) {
            this.UserRegion = {
              country: this.user.country,
              currency: this.user.currency,
              lang: this.user.language ?? 'en'
            }
            this._languageService.arabic.next(this.user.language == 'ar');
            this.browserService.getLocalStorage()?.setItem('UserRegion', JSON.stringify(this.UserRegion));
            this.storeChangeServ.setUserRegiona(this.UserRegion);
            this.setTranslateLocalstorgeAndDir()
          }
        }
      )
    ).subscribe()
  }

  setTranslateLocalstorgeAndDir() {
    if (!isPlatformBrowser(this.platformId)) return;

    let body: HTMLElement = document.querySelector('.app')!;
    let swiper = document.querySelector('.swiper-wrapper');

    this._languageService.arabic.pipe(
      distinctUntilChanged(),
      tap(
        ar => {
          this.arabic = ar;
          if (ar) {
            this._translateService.use('ar').subscribe();
            localStorage.setItem('lang', 'ar');
            this.UserRegion.lang = 'ar'
            if (!this.browserService.getLocalStorage()?.getItem('UserRegion')) {
              console.log('regional storage');
              localStorage.setItem('UserRegion', JSON.stringify(this.UserRegion))
            }
            this.storeChangeServ.setUserRegiona(this.UserRegion)
            body.style.direction = 'rtl';
            this.onLoopComplete();
            this._languageService.changeLangToArabic(location.pathname)
          } else {
            this._translateService.use('en').subscribe();
            localStorage.setItem('lang', 'en');
            this.UserRegion.lang = 'en'
            if (!this.browserService.getLocalStorage()?.getItem('UserRegion')) {
              console.log('regional storage');
              localStorage.setItem('UserRegion', JSON.stringify(this.UserRegion))
            }
            this.storeChangeServ.setUserRegiona(this.UserRegion)
            body.style.direction = 'ltr'
            this.onLoopComplete()
            this._languageService.changeLangToArabic(location.pathname)
          }
        }
      )
    ).subscribe(noop)
  }

  validateUser() {
    this.subscription.add(
      this.authServ.validate().subscribe({
        next: (response) => {
          this.user = response;
          this.storeChangeServ.setUser(response);
          this.authServ.updateUserShop(response);
          const sessionStorageBr = this.browserService.getSessionStorage();
          const localStorageBr = this.browserService.getLocalStorage();
          if (sessionStorageBr) {
            sessionStorage.setItem('userExist', 'true')
          }

          this.handlingTranslateWhenStart()


          this.storeChangeServ.getActivatedCurrency().pipe(
            distinctUntilChanged(
              (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
            ),
            tap(
              res => {
                this.activeCurrency = res.key;
                if (res.key) {
                  this.getUserCart();
                }
              }
            )
          ).subscribe()
          this.onLoopComplete()
        }, error: (response) => {
          const sessionStorageBr = this.browserService.getSessionStorage();
          const localStorageBr = this.browserService.getLocalStorage();
          if (sessionStorageBr) {
            sessionStorage.setItem('userExist', 'false')
          }

          this.handlingTranslateWhenStart()

          this.onLoopComplete()
        }
      })
    );
  }


  getUserCart(): void {
    const localStorageBr = this.browserService.getLocalStorage();
    if (localStorageBr) {
      this.subscription.add(
        this.cartService.getCart(this.activeCurrency).subscribe({
          next: (response) => {
            this.storeChangeServ.setCart(response);
          },
        })
      );
    }
  }


  getExchangeRate() {
    this.subscription.add(
      this.exchangeServ.getUserExchange().subscribe((exchange) => {
        this.storeChangeServ.setExchange(exchange);
      })
    );
  }

  onLoopComplete(): void {
    this.showLoading = false;
    this._languageService.onLoadComplete.next(false)
  }



  updateMetaTags() {
    if (!this.webSettingConfig) return;

    const title = this.webSettingConfig.title?.en || 'Card4Games';
    const description = this.webSettingConfig.meta_description?.en || 'Card4Games - Digital Gaming Cards Store';
    const keywords = this.webSettingConfig.meta_keyword?.en || 'gaming cards, gift cards, subscriptions';
    const image = this.webSettingConfig.logo || `${this.linksService.URLApp}/assets/logo-web-2.png`;
    const url = this.linksService.URLApp;

    this.seoService.setSeo({
      title,
      description,
      keywords,
      image,
      url,
      type: 'website'
    });
  }

  addStructuredData() {
    if (!this.webSettingConfig) return;

    const siteUrl = this.linksService.URLApp || 'https://card4games.com';
    const structuredData = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${siteUrl}/#organization`,
          name: 'Card4Games',
          url: siteUrl,
          logo: this.webSettingConfig.logo || `${siteUrl}/assets/logo-web-2.png`,
          description: this.webSettingConfig.meta_description?.en || 'Card4Games Digital Gaming Store',
          sameAs: [
            this.linksService.facebook || '',
            this.linksService.instgram || ''
          ].filter(Boolean)
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'Card4Games',
          publisher: {
            '@id': `${siteUrl}/#organization`
          },
          potentialAction: {
            '@type': 'SearchAction',
            target: `${siteUrl}/en/categories?search={search_term_string}`,
            'query-input': 'required name=search_term_string'
          }
        }
      ]
    };

    this.seoService.setStructuredData(structuredData);
  }


  // !  =========>>  Target ALerts  <<============
  getTargetAlerts() {
    this.storeChangeServ.getUser().subscribe(
      res => {

        if (res?._id) {

          let params = makeQueryParams({
            countryCode: res.countryCode,
            timeZone: res.lastLogin
          })

          this._targetAlertsService.getTargetAlerts(params).pipe(
            tap(
              response => {
                response.map(ele => {
                  this._messageService.add({ severity: 'info', summary: ele.title[this.arabic ? 'ar' : 'en'], detail: ele.body[this.arabic ? 'ar' : 'en'], life: 10000 });
                  this._targetAlertsService.markAlertViewed(ele._id).pipe(
                    tap(
                      mark => {

                      }
                    )
                  ).subscribe(noop)
                })
              }
            )
          ).subscribe(noop);

        }
      }
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}